import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Icon, message } from 'antd';
import { FaGavel } from 'react-icons/fa';
import { ethers } from 'ethers';
// API & Contract calls
import { addJudge as addJudgeApi } from '../../api-calls/customWagers';
import { addJudge as addContractJudge } from '../../contract/CustomWagersController';


Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore"])
class AddJudgeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            addingJudgeLoading: false,
            judgeEthAddress: '',
            validJudgeAddress: <div style={{ fontSize: '24px', marginTop: '10px', textAlign: 'center' }}><Icon type="loading" /></div>,
            isValid: false
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleClickSubmitAddJudge = this.handleClickSubmitAddJudge.bind(this);
        this.handleChangeJudgeAddress = this.handleChangeJudgeAddress.bind(this);
        this.checkEnsName = this.checkEnsName.bind(this);
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    componentDidMount() {
        this.setState({ validJudgeAddress: <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'center', color: "#ff4d4f" }}>NOT A VALID ADDRESS <Icon type="exclamation-circle" /></div> });
    }

    handleChangeJudgeAddress(e) {
        let name = e.target.value;
        this.setState({
            validJudgeAddress: <div style={{ fontSize: '24px', marginTop: '10px', textAlign: 'center' }}><Icon type="loading" /></div>
        });
        //Validity Check
        this.setState({ judgeEthAddress: e.target.value });

        if (!this.props.web3Store.web3.utils.isAddress(e.target.value)) {

            if (name.slice(-4) === ".eth" || name.slice(-5) === ".test") {
                this.checkEnsName(e.target.value);
            } else {
                this.setState({ isValid: false, validJudgeAddress: <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'center', color: "#ff4d4f" }}>NOT A VALID ADDRESS <Icon type="exclamation-circle" /></div> });


            }
        } else {
            this.setState({ isValid: true, validJudgeAddress: <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'center', color: "#a9ffbd" }}>{name} <Icon type="check-circle" /></div> });

        }
    }

    checkEnsName(name) {
        let defaultProvider = new ethers.providers.Web3Provider(this.props.web3Store.web3.currentProvider);
        defaultProvider.resolveName(name).then((address) => {
            console.log("ENS add: " + address);
            if (address === null) {
                this.setState({ isValid: false, validJudgeAddress: <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'center', color: "#ff4d4f" }}>NOT A VALID ADDRESS <Icon type="exclamation-circle" /></div> });


            } else {
                this.setState({ isValid: true, judgeEthAddress: address, validJudgeAddress: <div style={{ fontSize: '14px', marginTop: '10px', textAlign: 'center', color: "#a9ffbd" }}>{name} <Icon type="check-circle" /></div> });
            }
        })
    }

    handleClickSubmitAddJudge() {

        const { AuthStore } = this.props;
        let self = this;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let judgeAddress = this.state.judgeEthAddress;
        let wagerId = this.props.wagerId;
        let wagerBytes32Id = this.props.wagerBytes32Id;
        console.log("wagerId ::::" + wagerId)
        console.log("wagerBytes32Id ::::" + wagerId)
        if (this.state.isValid) {
            this.setState({ addingJudgeLoading: true })
            return addContractJudge(wagerBytes32Id, judgeAddress).then(
                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! No judge assigned.");
                        self.setState({ addingJudgeLoading: false });
                    } else {
                        return addJudgeApi(
                            authToken,
                            wagerId,
                            judgeAddress)
                            .then(() => {
                                self.setState({ addingJudgeLoading: false });
                                message.success("Judge successfully added!");
                                self.closeModal();
                                return self.props.UserStore.updateUserBets(AuthStore.userAuth.auth.accessToken);
                            })
                    }
                });

        } else {
            message.warning("Must input a valid ETH address or ENS name!");
        }
    }

    render() {
        return (
            <div className="custom-bets-add-judge-modal-open-btn" >
                <button className="custom-btn-primary" onClick={this.openModal}><FaGavel /> Assign a Judge</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Add Judge Modal"
                    className="add-judge-modal"
                    overlayClassName="add-judge-modal-overlay"
                >
                    <div className="add-judge-modal-content-wrap">
                        <div className="add-judge-modal-content-header">
                            Assign a Judge
                            <div className="add-judge-modal-content-header-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                        </div>
                        <div className="add-judge-modal-content">
                            {!this.state.addingJudgeLoading ?
                                <div className="add-judge-modal-content-form-field">
                                    <div className="add-judge-modal-content-form-field-title">Judge Address or ENS Name</div>
                                    <input type="text"
                                        onChange={this.handleChangeJudgeAddress}
                                        value={this.state.judgeEthAddress}
                                        className="custom-input"
                                        placeholder="Enter Judge's ETH Address"
                                    />
                                    {this.state.validJudgeAddress}
                                </div>
                                :
                                <div style={{ fontSize: '54px', marginTop: '10px', textAlign: 'center' }}><Icon type="loading" /></div>
                            }
                        </div>
                        <div className="add-judge-modal-actions">
                            <button onClick={this.closeModal} className="custom-btn-danger">Cancel</button>
                            <button onClick={this.handleClickSubmitAddJudge} className="custom-btn-primary">Submit</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default inject('store')(observer(AddJudgeModal));


// WEBPACK FOOTER //
// ./src/components/modals/AddJudgeModal.js